import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * A ratio drawn as a row of tick marks rather than a solid bar.
 *
 * Reads as a count, not a percentage: at a glance you see roughly how many of
 * the whole are filled, which is what an operator wants from "23 of 70 lockers
 * online". A continuous fill hides the count; a two-slice pie spends a whole
 * chart on a single number.
 *
 * The unfilled ticks are a lighter step of the same ink, so the state reads
 * across the whole bar instead of only where the fill stops.
 */
const TickMeter = ({ value = 0, total = 0, ticks = 28, tone = "bg-foreground", className }) => {
  const ratio = total > 0 ? Math.min(1, Math.max(0, value / total)) : 0;
  const filled = Math.round(ratio * ticks);

  return (
    <div
      className={cn("flex h-4 w-full items-end gap-[2px]", className)}
      role="img"
      aria-label={`${value} / ${total}`}
    >
      {Array.from({ length: ticks }, (_, i) => (
        <span
          key={i}
          className={cn(
            "h-full flex-1 rounded-[1px] transition-colors duration-300",
            i < filled ? tone : "bg-muted-foreground/20"
          )}
        />
      ))}
    </div>
  );
};

export { TickMeter };
